import React, { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Content } from "@/layout";
import {
    Badge,
    Heading,
    LoadingProgress,
    Panel,
    Table,
    TableToolbar,
    Text,
} from "@/ui";
import { useMeta } from "@/hooks";
import { QUERY_LIST_DELIVERY_WORKERS_IN_LOCATION } from "apollo/module-operations/delivery";
import styles from "../store/GeneralsForm.module.scss";

const OnfleetDrivers = () => {
    const { user } = useMeta();

    const {
        data: drivers_data,
        loading,
        refetch,
        networkStatus,
    } = useQuery(QUERY_LIST_DELIVERY_WORKERS_IN_LOCATION, {
        notifyOnNetworkStatusChange: true,
        skip: user.loading || !user.accountId || !user.storeId,
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
        },
    });

    const columns = useMemo(
        () => [
            {
                id: "name",
                header: "Name",
                minWidth: 180,
                renderCell: row => row.name || "",
            },
            {
                id: "id",
                header: "Id",
                minWidth: 180,
                renderCell: row => (
                    <span style={{ fontWeight: 500 }}>{row.id}</span>
                ),
            },
            {
                id: "phone",
                header: "Phone",
                minWidth: 140,
                renderCell: row => row.phone || "",
            },
            {
                id: "on_duty",
                header: "On duty",
                minWidth: 120,
                renderCell: row => (
                    <Badge variant={row.on_duty ? "primary" : "neutral"}>
                        {row.on_duty ? "True" : "False"}
                    </Badge>
                ),
            },
        ],
        [],
    );

    const _loading = loading || networkStatus === 4;

    const _drivers = (drivers_data && drivers_data.listWorkersInLocation) || [];

    return (
        <Content>
            <Panel
                className={styles.root}
                header={
                    <div className={styles.headerBar}>
                        <div className={styles.headerText}>
                            <Heading level={4}>Drivers</Heading>
                            <Text tone="secondary" variant="body-md">
                                All our drivers in the system
                            </Text>
                        </div>
                    </div>
                }
                showHeaderDivider
            >
                {_loading ? (
                    <div className={styles.loading}>
                        <LoadingProgress
                            indeterminate
                            indicator="circular"
                            size="sm"
                            title="Loading"
                        />
                    </div>
                ) : (
                    <>
                        <TableToolbar
                            count={_drivers.length}
                            label="Drivers"
                            mode="title"
                            onRefresh={() => refetch()}
                            searchable={false}
                            showMoreFilters={false}
                            updatedAtLabel=""
                        />
                        <Table
                            columns={columns}
                            emptyMessage="No drivers found"
                            getRowId={row => String(row.id)}
                            rows={_drivers}
                        />
                    </>
                )}
            </Panel>
        </Content>
    );
};

export default OnfleetDrivers;
